"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button"));
var contexts_1 = require("../../contexts");
var FormatText_1 = __importDefault(require("../FormatText"));
var __1 = require("../..");
var FormSubmitButton = function (props) {
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    var onClick = props.onClick, noIcon = props.noIcon, children = props.children, validate = props.validate, validateField = props.validateField, buttonProps = __rest(props, ["onClick", "noIcon", "children", "validate", "validateField"]);
    var handleClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var validationResult, textNotification_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!formProps) return [3, 3];
                    if (!onClick) return [3, 2];
                    return [4, formProps.validateForm()];
                case 1:
                    validationResult = _a.sent();
                    if (Object.keys(validationResult).length === 0) {
                        onClick(formProps.values, formProps);
                    }
                    else if (validate && validateField) {
                        textNotification_1 = 'O(s) Campo(s) ';
                        Object.keys(validationResult).forEach(function (i) {
                            textNotification_1 += validateField[i] + ", ";
                        });
                        textNotification_1 += ' não está(ão) preenchido(s)!';
                        __1.notification.warn('', textNotification_1);
                    }
                    return [3, 3];
                case 2:
                    formProps.submitForm();
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    return (react_1.default.createElement(Button_1.default, __assign({ icon: noIcon ? undefined : 'commons-ok' }, buttonProps, { onClick: handleClick }), children || react_1.default.createElement(FormatText_1.default, { id: "ui.commons.form.submit", uppercase: true })));
};
exports.default = FormSubmitButton;
